// extracted by mini-css-extract-plugin
export default {"top":"Addons_top__x9l+i","btnWrapper":"Addons_btnWrapper__38va-","wrapper":"Addons_wrapper__to+JA"};